<template>
  <div class="main_style">
    <navbar />

    <p class="font-title mx-4 px-4">บันทึกข้อมูลธนาคาร</p>
    <b-table-simple
      hover
      responsive=""
      style="margin-left: auto; margin-right: auto; width: 80%"
    >
      <b-tr>
        <b-th>ลำดับ</b-th>
        <b-th>รหัสข้อมูล</b-th>
        <b-th>ชื่อพืช</b-th>
        <b-th>ชื่อแปลงสำรวจ</b-th>
        <b-th>ประเภทแปลง</b-th>
        <b-th>ชื่อชุมชน</b-th>
        <b-th>วันที่บันทึก</b-th>
        <b-th>สถานะ</b-th>
      </b-tr>
      <tr v-for="(item, i) in list_save" :key="item.id">
        <b-td>{{ i + 1 }}</b-td>
        <b-td> {{ item.plants.plant_code }}</b-td>
        <b-td>{{ item.plants.bio_name }}</b-td>
        <b-td>{{ item.survey_plot_name }}</b-td>
        <b-td>แปลงสำรวจ</b-td>
        <b-td>{{ item.community }}</b-td>
        <b-td>{{ item.survey_date }}</b-td>
        <b-td>{{ item.plants.status }}</b-td>
      </tr>
    </b-table-simple>
    <b-row>
      <b-col
        class="rectangle_box py-3 my-3"
        cols="12"
        lg="10"
        md="12"
        sm="12"
        xl="8"
      >
        <b-row class="mx-1">
          <b-col class="d-flex justify-content-start btn-normal"
            >ข้อมูลแปลงธนาคาร
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6" md="6" sm="12" cols="12">
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-md-right text-sm-right text-left mx-3"
                cols="12"
                md="4"
                sm="4"
                ><b class="font-require">*</b>วันที่จัดเก็บ
              </b-col>
              <b-col cols="10" md="6" sm="6" class="mx-auto">
                <b-input
                  type="date"
                  class="input_text w-100"
                  style="height: 38px"
                  v-model="bank_form.bank_date"
                  :min="recentDate"
                />
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-md-right text-sm-right text-left mx-3"
                cols="12"
                md="4"
                sm="4"
                >จำนวน/ต้น
              </b-col>
              <b-col cols="10" md="6" sm="6" class="mx-auto">
                <b-form-input
                  v-model="bank_form.bank_amount"
                  class="input_text bank"
                  placeholder="จำนวน"
                  onkeydown="if(event.key==='.'){event.preventDefault();}"
                  oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                  type="number"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <!--              <b-col class="my-2" cols="12" md="12" sm="12">-->
              <b-col
                align="center"
                class="text-lg-right text-md-right text-sm-right text-left mx-3"
                cols="12"
                md="4"
                sm="4"
                >พิกัดต้นพันธุ์
              </b-col>
              <b-col cols="10" md="6" sm="6" class="mx-auto">
                <b-row class="d-flex justify-content-center">
                  <b-col cols="5" class="none-padding-right">
                    <b-form-input
                      v-model="bank_form.bank_bio_lat"
                      class="input_text"
                      placeholder="ละติจูด"
                      type="number"
                    ></b-form-input>
                  </b-col>
                  <b-col cols="5" class="none-padding-right">
                    <b-form-input
                      v-model="bank_form.bank_bio_lon"
                      class="input_text"
                      placeholder="ลองติจูด"
                      type="number"
                    ></b-form-input>
                  </b-col>
                  <b-col cols="2">
                    <div>
                      <button
                        @click="$bvModal.show('bv-modal-BankBio')"
                        class="btn-circle-no-margin"
                      >
                        <b-icon class="text-white" icon="geo-alt"></b-icon>
                      </button>
                      <b-modal id="bv-modal-BankBio" hide-footer>
                        <template #modal-header="{ close }">
                          <div>กรุณาเลือกพิกัด</div>
                          <div class="pointer" @click="close()">x</div>
                        </template>
                        <gmap-map
                          id="bank_bio"
                          :center="startLocation"
                          :zoom="15"
                          style="width: 100%; height: 420px"
                          @click="setPlaceNEWBankBio"
                        >
                          <!-- สร้าง marker ตามค่า coordinates ที่เราเซตไว้ แล้ว loop ออกมาแสดงผล -->
                          <gmap-marker
                            v-for="(item, key) in this.markers_bank_bio"
                            :key="key"
                            :clickable="true"
                            :position="getPositionBankBio(item)"
                            @click="toggleInfoBankBio()"
                          ></gmap-marker>
                        </gmap-map>
                      </b-modal>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="6" md="6" sm="12" cols="12">
            <template v-if="this.bank.length > 0">
              <b-row class="mt-3">
                <b-col
                  align="center"
                  class="text-lg-right text-left mx-3"
                  cols="12"
                  lg="3"
                  md="10"
                  >ข้อมูลแปลงธนาคาร
                </b-col>
                <b-col cols="10" md="6" sm="6" class="mx-auto">
                  <multiselect
                    id="survey"
                    v-model="bank_selected"
                    :initialValues="this.bank_selected"
                    :options="this.bank_option"
                    class="multiselect-style2 custom-multiselect"
                    deselect-label="ยกเลิก"
                    label="name"
                    placeholder="แปลง"
                    select-label=""
                    selectedLabel=""
                    track-by="name"
                  ></multiselect>
                </b-col>
              </b-row>
            </template>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-md-right text-sm-right text-left mx-3"
                cols="12"
                md="4"
                sm="4"
                >รหัสแปลงธนาคาร
              </b-col>
              <b-col cols="10" md="6" sm="6" class="mx-auto">
                <b-form-input
                  v-model="bank_form.bank_plot_code"
                  class="input_text bank"
                  placeholder="รหัสแปลงธนาคาร"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-md-right text-sm-right text-left mx-3"
                cols="12"
                md="4"
                sm="4"
                >ชื่อแปลง
              </b-col>
              <b-col cols="10" md="6" sm="6" class="mx-auto">
                <b-form-input
                  v-model="bank_form.bank_plot_name"
                  class="input_text bank"
                  placeholder="ชื่อแปลง"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col
                align="center"
                class="text-lg-right text-md-right text-sm-right text-left mx-3"
                cols="12"
                md="4"
                sm="4"
                ><b class="font-require">*</b>ที่ตั้งแปลง
              </b-col>
              <b-col cols="10" md="6" sm="6" class="mx-auto">
                <b-form-input
                  v-model="bank_form.bank_plot_address"
                  class="input_text bank"
                  placeholder="ที่ตั้งแปลง"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="
                      text-lg-right text-md-right text-sm-right text-left
                      mx-3
                    "
                    cols="12"
                    md="4"
                    sm="4"
                    ><b class="font-require">*</b>จังหวัด
                  </b-col>
                  <b-col cols="10" md="6" sm="6" class="mx-auto">
                    <multiselect
                      id="bank_plot_province"
                      @input="getDistrict(province_bank_selected, 'bank')"
                      @select="
                        (opt) => (bank_form.bank_plot_province = opt.code)
                      "
                      v-model="province_bank_selected"
                      :options="this.province_bank"
                      label="name"
                      select-label=""
                      selectedLabel=""
                      deselect-label="ยกเลิก"
                      track-by="name"
                      class="multiselect-style2 custom-multiselect"
                      placeholder="จังหวัด"
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="
                      text-lg-right text-md-right text-sm-right text-left
                      mx-3
                    "
                    cols="12"
                    md="4"
                    sm="4"
                    ><b class="font-require">*</b>อำเภอ
                  </b-col>
                  <b-col cols="10" md="6" sm="6" class="mx-auto">
                    <multiselect
                      id="bank_plot_district"
                      :disabled="province_bank_selected.length <= 0"
                      @input="getSubDistrict(district_bank_selected, 'bank')"
                      @select="
                        (opt) =>
                          (bank_form.bank_plot_district = opt.district_id)
                      "
                      v-model="district_bank_selected"
                      :options="this.district_bank"
                      label="name"
                      select-label=""
                      selectedLabel=""
                      deselect-label="ยกเลิก"
                      track-by="name"
                      class="multiselect-style2 custom-multiselect"
                      placeholder="อำเภอ"
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="
                      text-lg-right text-md-right text-sm-right text-left
                      mx-3
                    "
                    cols="12"
                    md="4"
                    sm="4"
                    ><b class="font-require">*</b>ตำบล
                  </b-col>
                  <b-col cols="10" md="6" sm="6" class="mx-auto">
                    <multiselect
                      id="bank_plot_sub_district"
                      :disabled="district_bank_selected.length <= 0"
                      @input="
                        (opt) =>
                          (bank_form.bank_plot_sub_district =
                            opt.subdistrict_id)
                      "
                      @select="sub_district_bank_selected"
                      v-model="sub_district_bank_selected"
                      :options="this.sub_district_bank"
                      label="name"
                      select-label=""
                      selectedLabel=""
                      deselect-label="ยกเลิก"
                      track-by="name"
                      class="multiselect-style2 custom-multiselect"
                      placeholder="ตำบล"
                    ></multiselect>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col class="my-2" cols="12" md="12" sm="12">
                <b-row>
                  <b-col
                    align="center"
                    class="
                      text-lg-right text-md-right text-sm-right text-left
                      mx-3
                    "
                    cols="12"
                    md="4"
                    sm="4"
                    ><b class="font-require">*</b>พิกัดต้นพันธุ์
                  </b-col>
                  <b-col cols="10" md="6" sm="6" class="mx-auto">
                    <b-row class="d-flex justify-content-center">
                      <b-col cols="5" class="none-padding-right">
                        <b-form-input
                          v-model="bank_form.bank_plot_lat"
                          class="input_text"
                          placeholder="ละติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="5" class="none-padding-right">
                        <b-form-input
                          v-model="bank_form.bank_plot_lon"
                          class="input_text"
                          placeholder="ลองติจูด"
                          type="number"
                        ></b-form-input>
                      </b-col>
                      <b-col cols="2">
                        <div>
                          <button
                            @click="$bvModal.show('bv-modal-BankPlot')"
                            class="btn-circle-no-margin"
                          >
                            <b-icon class="text-white" icon="geo-alt"></b-icon>
                          </button>
                          <b-modal id="bv-modal-BankPlot" hide-footer>
                            <template #modal-header="{ close }">
                              <div>กรุณาเลือกพิกัด</div>
                              <div class="pointer" @click="close()">x</div>
                            </template>
                            <gmap-map
                              id="bank_plot"
                              :center="startLocation"
                              :zoom="15"
                              style="width: 100%; height: 420px"
                              @click="setPlaceNEWBankPlot"
                            >
                              <!-- สร้าง marker ตามค่า coordinates ที่เราเซตไว้ แล้ว loop ออกมาแสดงผล -->
                              <gmap-marker
                                v-for="(item, key) in this.markers_bank_plot"
                                :key="key"
                                :clickable="true"
                                :position="getPositionBankPlot(item)"
                                @click="toggleInfoBankPlot()"
                              ></gmap-marker>
                            </gmap-map>
                          </b-modal>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="d-block text-left mr-auto mx-auto" md="4" cols="6">
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" xl="6">
            <b-button
              class="text-center my-2 pb-3 btn btn-block"
              style="background: white; border-radius: 25px; color: #bdbdbd"
              to="/Survey"
            >
              ยกเลิก
            </b-button>
          </b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="6">
            <b-button
              class="text-center my-2 pb-3 btn btn-block"
              style="background: #db7f50; border-radius: 25px"
              @click="saveFormBank('1')"
            >
              บันทึกฉบับร่าง
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="d-block text-right ml-auto mx-auto" md="4" cols="6">
        <b-row>
          <b-col cols="12" sm="12" md="12" lg="12" xl="6"></b-col>
          <b-col cols="12" sm="12" md="12" lg="12" xl="6">
            <b-button
              class="text-center my-2 pb-3 btn btn-block"
              style="background: #41634a; border-radius: 25px"
              @click="saveFormBank('2')"
            >
              บันทึกและตรวจสอบ
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import navbar from "@/components/navbar";
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import moment from "moment";
import plantsModule from "@/store/modules/plantsModule";

export default {
  name: "SaveBank",
  components: {
    navbar,
    Multiselect,
  },
  data() {
    return {
      bank_selected: [],
      bank_option: [],
      recentDate:null,
      markers_bank_bio: [],
      markers_bank_plot: [],
      startLocation: {
        lat: 13.7649084,
        lng: 100.5382846,
      },
      province_bank_selected: [],
      district_bank_selected: [],
      sub_district_bank_selected: [],
    };
  },
  created() {
    this.$store.dispatch("plantsModule/clearBankPlant");
    this.getOption();
    this.recentDate = this.getRecentSurveyDate(this.list_save);
  },
  computed: {
    ...mapState({
      list_save: (state) => state.plantsModule.list_save,
      bank_form: (state) => state.plantsModule.bank_form,
      province_bank: (state) => state.OptionsModule.province_bank,
      district_bank: (state) => state.OptionsModule.district_bank,
      sub_district_bank: (state) => state.OptionsModule.sub_district_bank,
      province: (state) => state.OptionsModule.province,
      district: (state) => state.OptionsModule.district,
      sub_district: (state) => state.OptionsModule.sub_district,
      accessToken: (state) => state.AuthModule.accessToken,
      user: (state) => state.AuthModule.userData,
      bank: (state) => state.OptionsModule.bank,
    }),
  },
  mounted() {
    //setStart Lat ,Lon
    if (!this.startLocation) {
      this.geolocationBankBio();
      this.geolocationBankPlot();
    }
  },
  methods: {
    //getRecent survey date
    getRecentSurveyDate(list){
      let dateList = list.map(d => moment(d.survey_date));
      let maxdate = moment.max(dateList)
      return moment(maxdate).format(moment.HTML5_FMT.DATE)
    },
    //Prepare Data
    getOption() {
      this.$store.dispatch("OptionsModule/onGetOption");
      this.bank.forEach((item) => {
        this.bank_option.push({
          id: item.id,
          name: item.bank_plot_name,
        });
      });
    },
    //google map bank bio
    getPositionBankBio(marker) {
      this.bank_form.bank_bio_lat = parseFloat(marker.position.lat);
      this.bank_form.bank_bio_lon = parseFloat(marker.position.lng);
      return {
        lat: parseFloat(marker.position.lat),
        lng: parseFloat(marker.position.lng),
      };
    },
    toggleInfoBankBio() {
      this.infoOpened = true;
    },
    setLocationBankBio(marker) {
      console.log(marker);

      this.markers_bank_bio.pop();
      this.markers_bank_bio.push({ position: marker });
      this.bank_form.bank_bio_lat = marker.lat;
      this.bank_form.bank_bio_lon = marker.lng;
      this.startLocation.lat = this.bank_form.bank_bio_lat;
      this.startLocation.lng = this.bank_form.bank_bio_lon;
      this.center = marker;
      // if(this.form.location_province){
      //     this.form.location_province= null;
      //     this.form.location_district= null;
      //     this.form.location_sub_district= null;
      // }
    },
    geolocationBankBio() {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          var current = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };

          var google_map_pos = new google.maps.LatLng(current.lat, current.lng);

          var self = this;
          /* Use Geocoder to get address */
          var google_maps_geocoder = new google.maps.Geocoder();
          google_maps_geocoder.geocode(
            { latLng: google_map_pos }
            // function (results, status) {
            //   if (status == google.maps.GeocoderStatus.OK && results[0]) {
            //     self.getAddress(results[0]);
            //   }
            // }
          );

          this.setLocationBankBio(current);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    setPlaceBankBio(place) {
      //"1839 Phahonyothin Rd, Khwaeng Lat Yao, Khet Chatuchak, Krung Thep Maha Nakhon 10900, Thailand"
      this.currentPlace = place;
      if (this.currentPlace) {
        this.form.location = place.name;
        // this.form.location_province = place.address_components[3].long_name;
        // this.form.location_district = place.address_components[2].long_name;
        // this.form.location_sub_district = place.address_components[1].long_name;

        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.setLocationBankBio(marker);
        this.places.push(this.currentPlace.name);

        console.log("place", place);
        this.getAddress(place);
      } else if (this.form.name) {
        this.places.push(this.form.name);
      }
    },
    setPlaceNEWBankBio(place) {
      console.log("newPlace", place);
      let latLngtxt = place.latLng.toString();
      var setlatLng = latLngtxt.split(/[\s,()]+/);
      const marker = {
        lat: Number(setlatLng[1]),
        lng: Number(setlatLng[2]),
      };

      // console.log(marker);

      this.setLocationBankBio(marker);

      var geocoder = new google.maps.Geocoder();
      var self = this;
      geocoder.geocode(
        { location: place.latLng, language: "th" },
        function (results, status) {
          if (status === "OK") {
            console.log("results", results);
            // results.forEach(self.getAddress);
            // self.getAddress(results[0]);
          }
        }
      );
      //
      // let newCurrentPlace = place.latLng.toString()
      // let latLng = newCurrentPlace.split(/[\s,()]+/)
      // this.currentPosition = { lat: Number(latLng[1]), lng: Number(latLng[2]) }
      // console.log(place);
    },

    //googlemap bank plot
    getPositionBankPlot(marker) {
      this.bank_form.bank_plot_lat = parseFloat(marker.position.lat);
      this.bank_form.bank_plot_lon = parseFloat(marker.position.lng);
      return {
        lat: parseFloat(marker.position.lat),
        lng: parseFloat(marker.position.lng),
      };
    },
    toggleInfoBankPlot() {
      this.infoOpened = true;
    },
    setLocationBankPlot(marker) {
      console.log(marker);

      this.markers_bank_plot.pop();
      this.markers_bank_plot.push({ position: marker });
      this.bank_form.bank_plot_lat = marker.lat;
      this.bank_form.bank_plot_lon = marker.lng;
      this.startLocation.lat = this.bank_form.bank_plot_lat;
      this.startLocation.lng = this.bank_form.bank_plot_lon;
      this.center = marker;
      // if(this.form.location_province){
      //     this.form.location_province= null;
      //     this.form.location_district= null;
      //     this.form.location_sub_district= null;
      // }
    },
    geolocationBankPlot() {
      console.log("current location", navigator.geolocation);
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          var current = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };

          var google_map_pos = new google.maps.LatLng(current.lat, current.lng);

          var self = this;
          /* Use Geocoder to get address */
          var google_maps_geocoder = new google.maps.Geocoder();
          google_maps_geocoder.geocode(
            { latLng: google_map_pos }
            // function (results, status) {
            //   if (status == google.maps.GeocoderStatus.OK && results[0]) {
            //     self.getAddress(results[0]);
            //   }
            // }
          );

          this.setLocationBankPlot(current);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    setPlaceBankPlot(place) {
      //"1839 Phahonyothin Rd, Khwaeng Lat Yao, Khet Chatuchak, Krung Thep Maha Nakhon 10900, Thailand"
      this.currentPlace = place;
      if (this.currentPlace) {
        this.form.location = place.name;
        // this.form.location_province = place.address_components[3].long_name;
        // this.form.location_district = place.address_components[2].long_name;
        // this.form.location_sub_district = place.address_components[1].long_name;

        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.setLocationBankPlot(marker);
        this.places.push(this.currentPlace.name);

        console.log("place", place);
        this.getAddress(place);
      } else if (this.form.name) {
        this.places.push(this.form.name);
      }
    },
    setPlaceNEWBankPlot(place) {
      console.log("newPlace", place);
      let latLngtxt = place.latLng.toString();
      var setlatLng = latLngtxt.split(/[\s,()]+/);
      const marker = {
        lat: Number(setlatLng[1]),
        lng: Number(setlatLng[2]),
      };

      // console.log(marker);

      this.setLocationBankPlot(marker);

      var geocoder = new google.maps.Geocoder();
      var self = this;
      geocoder.geocode(
        { location: place.latLng, language: "th" },
        function (results, status) {
          if (status === "OK") {
            console.log("results", results);
            // results.forEach(self.getAddress);
            // self.getAddress(results[0]);
          }
        }
      );
      //
      // let newCurrentPlace = place.latLng.toString()
      // let latLng = newCurrentPlace.split(/[\s,()]+/)
      // this.currentPosition = { lat: Number(latLng[1]), lng: Number(latLng[2]) }
      // console.log(place);
    },

    async getDistrict(province, name) {
      if (province) {
        let filter = [];
        filter = this.district.filter((data) => {
          return data.province_id == province.code;
        });
        let data = {
          name: name,
          filter: filter,
        };
        this.$store.dispatch("OptionsModule/setFilterDistrict", data);
      } else {
        this[`province_${name}_selected`] = [];
        this[`district_${name}_selected`] = [];
        this[`sub_district_${name}_selected`] = [];
      }
    },
    async getSubDistrict(district, name) {
      if (district) {
        let filter = [];
        filter = this.sub_district.filter((data) => {
          return data.district_id == district.district_id;
        });
        let data = {
          name: name,
          filter: filter,
        };
        this.$store.dispatch("OptionsModule/setFilterSubDistrict", data);
      } else {
        this[`district_${name}_selected`] = [];
        this[`sub_district_${name}_selected`] = [];
      }
    },
    async saveFormBank(type) {
      let plant_id = [];
      this.list_save.forEach((item) => {
        plant_id.push({
          id: item.plants.plant_id,
          type: type,
        });
      });
      let temp_data = this.bank_form;
      console.log("temp_data", temp_data);
      const valid = this.verifyData(temp_data);
      if (valid == 0) {
        let data = {
          data: {
            data: this.bank_form,
            plant_id: plant_id,
          },
          user: this.user.user,
          token: this.accessToken,
        };
        this.$store
          .dispatch("plantsModule/onSaveFormToBank", data)
          .then((res) => {
            if (res.code == 200) {
              if (res.result.message == "success") {
                Swal.fire({
                  icon: "success",
                  title: "เรียบร้อย!",
                });
              } else {
                Swal.fire({
                  icon: "error",
                  title: res.message,
                });
              }
              this.$store.dispatch("plantsModule/getAllPlants").then((res) => {
                if (res.code == 200) {
                  this.$router.push("/Survey");
                }
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "ผิดพลาด!",
              });
            }
          });
      } else {
        Swal.fire({
          icon: "error",
          title: "ผิดพลาด!",
          text: "โปรดกรอกข้อมูลให้ครบ",
        });
      }
    },
    verifyData(data) {
      let counting = 0;
      console.log("verifyData", data);
      let tempDataBank = document.getElementsByClassName("bank");
      let counting_bank = 0;
      tempDataBank.forEach((item) => {
        if (item.value) {
          counting_bank++;
        }
      });
      if (counting_bank > 0) {
        if (
          !data.bank_date ||
          !data.bank_plot_address ||
          this.province_bank_selected.length <= 0 ||
          this.district_bank_selected.length <= 0 ||
          this.sub_district_bank_selected.length <= 0 ||
          !data.bank_plot_lat ||
          !data.bank_plot_lon
        ) {
          counting++;
        }
      }
      console.log("counting", counting);
      return counting;
    },
  },
};
</script>

<style scoped lang="scss">
.btn-form {
  background-color: white;
  border: none;
}
</style>
